// extracted by mini-css-extract-plugin
export default {"tagline":"OriginalByDesign_tagline__Q23Vl","video":"OriginalByDesign_video__j6Drl","videoMobile":"OriginalByDesign_videoMobile__EUngg","award":"OriginalByDesign_award__uDb8u"};